import React from 'react';
import { useSelector } from 'react-redux';
import { CONTAINED_VARIANT, NO_ICON, SIZE_44 } from '@yme/atoms/button';
import { Container, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getRTL } from '@yme/selectors/common';
import { ButtonLinkStyled, CaptionStyled, ContentStyled, DescriptionStyled, ImageContainerStyled, ImageStyled, SubtitleStyled, TitleStyled, } from './styled';
export function ImageWithText(props) {
    const { title, subtitle, description, caption, imageAlign, image, button, isRemoveBottomIndent } = props;
    const isRightToLeft = useSelector(getRTL);
    const { isInfiniteDesktopView, isTabletView, isMobileView } = useWindowSize();
    const isImageAlignRight = imageAlign === 'right' && isInfiniteDesktopView;
    if (!image || !description) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, null,
            React.createElement(Row, { justifyContent: "center", flexDirection: isImageAlignRight ? 'row-reverse' : 'row' },
                React.createElement(ImageContainerStyled, { isRightToLeft: isRightToLeft, lg: 4 },
                    (isTabletView || isMobileView) && (React.createElement(React.Fragment, null,
                        title && React.createElement(TitleStyled, null, title),
                        subtitle && React.createElement(SubtitleStyled, null, subtitle))),
                    React.createElement(ImageStyled, { ...image }),
                    caption && React.createElement(CaptionStyled, { as: "p" }, caption)),
                React.createElement(ContentStyled, { isRightToLeft: isRightToLeft, lg: 4 },
                    isInfiniteDesktopView && (React.createElement(React.Fragment, null,
                        title && React.createElement(TitleStyled, null, title),
                        subtitle && React.createElement(SubtitleStyled, null, subtitle))),
                    React.createElement(DescriptionStyled, null, description),
                    button && (React.createElement(ButtonLinkStyled, { buttonLink: button.link, buttonWidth: isMobileView ? '100%' : 'auto', buttonLabel: button.text, size: SIZE_44, buttonVariant: CONTAINED_VARIANT, hasIconButton: NO_ICON })))))));
}
ImageWithText.displayName = 'ImageWithText_AEMComponent';
